import { MarketingLink } from "./MarketingButton";
import { marketingButtonClass } from "./marketingButtonClass";
import { MARKETING_PRODUCTS } from "./products";

const POINTS = [
  "Alternate versions",
  "Exclusive content",
  "One complete release",
];

export default function SuperSingleOverview() {
  const path = MARKETING_PRODUCTS.super.path;
  return (
    <section className="bg-[#F5F7FB] px-[6vw] py-28 text-marketing-ink max-[680px]:px-5 max-[680px]:py-[78px]">
      <div className="mx-auto grid w-[min(1240px,100%)] grid-cols-[0.78fr_1.22fr] items-center gap-[72px] max-[980px]:grid-cols-1 max-[980px]:gap-[46px]">
        <div className="min-w-0">
          <p className="mb-[18px] font-permanent-marker text-[clamp(42px,5vw,68px)] leading-[0.95] tracking-[-0.035em] text-blue-600 max-[680px]:text-[46px]">
            Super Single
            <sup className="ml-[7px] inline-block align-top font-figtree text-[13px] font-extrabold leading-none tracking-normal text-marketing-ink">
              TM
            </sup>
          </p>
          <h2 className="m-0 max-w-[520px] font-figtree text-[clamp(40px,4.5vw,64px)] font-black uppercase leading-[0.98] tracking-[-0.05em] max-[680px]:text-[40px]">
            Sell more than a song.
          </h2>
          <p className="mt-[25px] max-w-[560px] font-open-sans text-[18px] leading-[1.65] text-[#566078] max-[680px]:text-[17px]">
            Turn one single into a richer fan product by including the clean
            version, instrumental, acapella, video, or other exclusive content,
            without the extra work.
          </p>
          <div
            aria-label="Super Single benefits"
            className="mb-[30px] mt-7 flex flex-wrap gap-[10px]"
          >
            {POINTS.map((point) => (
              <span
                key={point}
                className="rounded-full border border-[#D8DEEC] bg-white px-[13px] py-[9px] font-figtree text-[13px] font-bold leading-none"
              >
                {point}
              </span>
            ))}
          </div>
          <MarketingLink to={path} className={marketingButtonClass("blue")}>
            Explore Super Singles
          </MarketingLink>
        </div>
        <MarketingLink
          to={path}
          aria-label="Explore Super Singles"
          className="block min-w-0 rotate-1 overflow-hidden rounded-[24px] border border-[#DCE1ED] bg-white shadow-[0_24px_60px_rgba(10,24,73,0.13)] transition-[transform,box-shadow] duration-200 hover:shadow-[0_30px_70px_rgba(10,24,73,0.17)] motion-safe:hover:-translate-y-1 motion-safe:hover:rotate-0 max-[680px]:rotate-0 max-[680px]:rounded-[18px]"
        >
          <img
            src="/marketing/super-single-published-view.webp"
            alt="A published Lutely Super Single with original, clean, and instrumental versions"
            loading="lazy"
            className="block h-auto w-full"
          />
        </MarketingLink>
      </div>
    </section>
  );
}
